import React, { useContext, useState } from "react";
import { Form, Input, DatePicker, theme } from "antd";
import {
  feedingTubeOptions,
  feedingTubeTypeOptions,
  tubeAspirationOptions,
  tubePositionOptions,
} from "../../../../Options/genExamOptions";
import dayjs from "dayjs";
import DeselectableRadioGroup from "../../../../../../blocks/FormItems/DeselectableRadioGroup";
import { hexToRgba } from "../../../../../../helpers/utility";
import { DoctorInitialContext } from "../../../HistoryForm/DoctorHistoryFormProvider";
import useIsMobile from "../../../../../../hooks/useIsMobile";

const FeedingTube = ({ dailyReview = false, form }) => {
  const [refresh, setRefresh] = useState(false);
  const isMobile = useIsMobile();
  const { formData } = useContext(DoctorInitialContext);
  const { token } = theme.useToken();
  const showFeedingTube = form.getFieldValue("feeding_tube");
  return (
    <>
      <DeselectableRadioGroup
        label={"Feeding Tube"}
        name={"feeding_tube"}
        options={feedingTubeOptions}
        form={form}
        setRefresh={setRefresh}
      />
      {showFeedingTube === "yes" && (
        <div
          className="subsection-card"
          style={{
            borderLeft: `2px solid ${hexToRgba(token.colorPrimaryHover, 0.2)}`,
            background: "transparent",
            marginTop: "8px",
            padding: "8px 12px",
            borderRadius: "8px",
          }}
        >
          <DeselectableRadioGroup
            name={"feeding_tube_type"}
            options={feedingTubeTypeOptions}
            form={form}
          />
          <DeselectableRadioGroup
            label={"Position"}
            name={"feedingtube_position"}
            options={tubePositionOptions}
            form={form}
          />

          {dailyReview ? (
            <Form.Item name="feedingtube_start_date" label="Start Date">
              <DatePicker
                className="gen-exam-datepicker"
                format="DD/MM/YYYY"
                allowClear
                inputReadOnly={isMobile}
                getPopupContainer={() => document.body}
                popupClassName={isMobile ? "curengo-mobile-picker" : undefined}
                placement="bottomLeft"
                style={{ width: isMobile ? "100%" : 280 }}
                disabledDate={(current) =>
                  current && current > dayjs().endOf("day")
                }
              />
            </Form.Item>
          ) : (
            <Form.Item name="feedingtube_no_days">
              <Input
                className="nurse-assessment-days-field gen-exam-compact-input"
                addonBefore="No.of Days"
              />
            </Form.Item>
          )}

          <DeselectableRadioGroup
            label={"Tube Aspirations"}
            name={"feedingtube_aspirations"}
            options={tubeAspirationOptions}
            form={form}
          />
        </div>
      )}
    </>
  );
};

export default FeedingTube;
